module.exports = {"350305100":"笏石镇","350305101":"东庄镇","350305102":"忠门镇","350305103":"东埔镇","350305104":"东峤镇","350305105":"埭头镇","350305106":"平海镇","350305107":"南日镇","350305108":"湄洲镇","350305109":"山亭镇","350305110":"月塘镇","350305400":"前沁农场","350305401":"后海管理局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350305.json
// module id = 1087
// module chunks = 0